import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CompletionApiService } from '../../api/completion-api.service';

/**
 * AudioTranscription - Handles audio transcription operations
 *
 * This service handles:
 * - Audio blob transcription using OpenAI Whisper
 * - Audio format validation
 * - Transcription error handling
 */
@Injectable({
  providedIn: 'root',
})
export class AudioTranscriptionService {
  constructor(private completionService: CompletionApiService) {}

  /**
   * Transcribe audio blob to text
   * (Now uses unified CompletionApiService - routes to OpenAI Whisper)
   */
  transcribeAudio(audioBlob: Blob): Observable<string> {
    // The backend returns a plain string (responseType: 'text'), not an object
    return this.completionService.transcribeAudio(audioBlob);
  }
}
